enum StatusAgenciaTransfusionalEnum {
  ContatoPendente = 'ContatoPendente',
  AguardandoPaciente = 'AguardandoPaciente',
  ColetaRealizada = 'ColetaRealizada',
  TestePendente = 'TestePendente',
  ReservaConfirmada = 'ReservaConfirmada'
}

export default StatusAgenciaTransfusionalEnum
